import React from "react";
import "./../../../pages/Representante_Instituição/Tela_RI_Pacientes_Cadastro/styles.css";
//import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
//import axios from 'axios';
import api from './../../../services/api';
import { user_token } from "../../../services/Auth";
import { withRouter } from "react-router-dom";
import { Spinner } from 'react-activity';
import 'react-activity/dist/react-activity.css'
import Collapse from 'react-collapse';

import {agent} from '../../../services/api';
let apiAgent = new agent();

var token = localStorage.getItem(user_token);
var _id = localStorage.getItem("id_agent");

class Form_RI_PacientesCadastro extends React.Component {
    constructor() {
        super();
        this.state = {
            user_type:"",
            name: "",
            adress: "",
            cpf: 0,
            createdAt: "",
            updatedAt: [],
            agent_id: "",
            birth: "",
            gender: "",
            first: true,
            medical_record: {
              professional_id: "",
              date: "",
              antecedents: "",
              medications_in_use: "",
              life_habits: {
                physical_activity: true,
                smoking: true,
                smoking_amount: "",
                alcoholism: true,
                alcoholism_amount: "",
                surgery: ""
              },
              family_history: "",
              current_complaints: "",
              physical_exam: "",
              complementary_exam: "",
              diagnosis: "",
              conduct: "",
              prescripted_drugs: "",
              requested_exams: "",
              medical_referral: "",
              note: ""
            },
            
            /*
            loading:false,
            agent_id: "",
            name: "",
            birth: "",
            gender: "",
            adress: "",
            cpf: "",
            first: true,
            medical_record: {
                professional_cpf: "",
                professional_name: "",
                date: "",
                antecedents: "",
                medications_in_use: "",
                life_habits: {
                    physical_activity: "",
                    smoking: "",
                    smoking_amount: 0,
                    alcoholism: "",
                    alcoholism_amount: "",
                    surgery: ""
                },
                family_history: "",
                current_complaints: "",
                physical_exam: "",
                complementary_exam: "",
                diagnosis: "",
                conduct: "",
                prescripted_drugs: "",
                requested_exams: "",
                medical_referral: "",
                note: "",
                createdAt: "",
                updatedAt: "",
            },
            monitoration_record: [], */
        };

        this.handleChange = this.handleChange.bind(this);
        this.handleSelect_g = this.handleSelect_g.bind(this);
        this.handleSelect_ut = this.handleSelect_ut.bind(this);
    }
    handleChange(evt) {
        this.setState({ [evt.target.name]: evt.target.value });
    }
    handleBirth(evt) {
        this.setState({ [evt.target.name]: evt.target.selected });
    }
    handleSelect_ut(event) {
        this.setState({ user_type: event.target.value });
    }
    handleSelect_g(event){
        this.setState({ gender: event.target.value});
    }

    _collapse(open) {
        if (open === false) {
            return true
        }
        else {
            return false
        }
    }
    _handleSubmit = evt => {
        evt.preventDefault();
        this.setState({loading: true})
        const user = {
            user_type: this.state.user_type,
            agent_id: _id,
            name: this.state.name,
            birth: this.state.birth,
            gender: this.state.gender,
            adress: this.state.adress,
            cpf: this.state.cpf,
            first: true,
            createdAt: this.state.createdAt,
            updatedAt: this.state.updatedAt,
            medical_record: this.state.medical_record = {
                professional_id: this.state.medical_record.professional_id,
                date: this.state.medical_record.date,
                antecedents: this.state.medical_record.antecedents,
                medications_in_use: this.state.medical_record.medications_in_use,
                life_habits: this.state.medical_record.life_habits,
                family_history: this.state.medical_record.family_history,
                current_complaints: this.state.medical_record.current_complaints,
                physical_exam: this.state.medical_record.physical_exam,
                complementary_exam: this.state.medical_record.complementary_exam,
                diagnosis: this.state.medical_record.diagnosis,
                conduct: this.state.medical_record.conduct,
                prescripted_drugs: this.state.medical_record.prescripted_drugs,
                requested_exams: this.state.medical_record.requested_exams,
                medical_referral: this.state.medical_record.medical_referral,
                note: this.state.medical_record.note,
                
            },

        };
        //console.log(JSON.stringify(user))
        //api.post(`/user`, user, { headers: { 'x-access-token': token } })
        apiAgent.createUser(user)
            .then(res => {
                console.log(res);
                console.log(res.data);
                this.setState({loading: false})
                alert("Paciente cadastrado com sucesso!");
                this.props.history.push("/RI_Painel");
            });
    }
    render() {

        return (
            <>
                <div id="collapsed-Cadastro-Paciente">
                    <form onSubmit={this._handleSubmit} id="RI-Cadastro-Paciente-Form">
                        <h1 id="tittle-forms-cme">Formulário de Cadastro</h1>
                        <br></br>
                        <p id="RI-Title-Cadastro-Paciente" >Nome completo do paciente</p>
                        <input onChange={this.handleChange} name="name" placeholder="Nome completo" type="text" id="RI-Cadastro-Paciente-Forms" required/>

                        <p id="RI-Title-Cadastro-Paciente" >Data de nascimento</p>
                        <input onChange={this.handleChange} name="birth" placeholder="Data de nascimento" type="date" id="RI-Cadastro-Paciente-Forms" required/>

                        <p id="RI-Title-Cadastro-Paciente" >Genêro</p>
                        <select value={this.state.gender} onChange={this.handleSelect_g} id="RI-Solicitar-Forms" required>
                            <option></option>
                            <option value='Masculino'>Masculino</option>
                            <option value='Feminino'>Feminino</option>
                            <option value='Outro'>Outro</option>
                        </select>
                        <p id="RI-Title-Cadastro-Paciente" >CPF do usuário</p>
                        <input name="cpf" onChange={this.handleChange} placeholder="CPF" type="text" id="RI-Cadastro-Paciente-Forms" />
                        <p id="RI-Title-Cadastro-Paciente" >Endereço</p>
                        <input name="adress" onChange={this.handleChange} placeholder="Endereço" value={this.state.adress} type="text" id="RI-Cadastro-Paciente-Forms" />
                        <p id="RI-Title-Solicitar">Selecione o tipo de paciente</p>
                        <select value={this.state.user_type} onChange={this.handleSelect_ut} id="RI-Solicitar-Forms" required>
                            <option></option>
                            <option value='Paciente'>Paciente da instituição</option>
                            <option value='Funcionario'>Funcionário da instituição</option>
                        </select>
                        <div style={{ display: "flex", justifyContent: "center" }}>
                            <button onClick={() => this._handleSubmit} id="option-RI-Cadastro-Paciente">
                                <Collapse isOpened={this.state.loading}>
                                    <Spinner color="#FFFFFF" />
                                </Collapse>
                                <p>Enviar</p>
                            </button>
                        </div>
                    </form>
                </div>
            </>
        );
    };
};
Form_RI_PacientesCadastro = withRouter(Form_RI_PacientesCadastro);
export default Form_RI_PacientesCadastro;